module.exports = __webpack_public_path__ + "static/media/doctor@2x.9d218c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Directions/doctor@2x.png
// module id = 661
// module chunks = 0